import { sendEmailAPI } from "./mail_service.js";
import { postData, postDataBS } from "./awsService.js";
import {
  FormResponseFormatToUser,
  GenerateEmailHTML,
  FormResponseFormatToMento,
  FromResponseFormatToContactus,
  UserPaymentConfirmation,
  UserPaymentConfirmationToMento,
} from "../components/mail/mailformat.js";
import ReactDOMServer from "react-dom/server";
import { initiatePayment } from "./payment_fetch.js";
import { FormResponseFormatToMento1 } from "../components/mail/mailformat.js";
import {
  AnxietyAssessmentResultFormat,
  DepressionAssessmentResultFormat,
  ToolResponsetoMentoFormat,
  WellbeingAssessmentResultFormat,
  mail_to_user_for_the_google_meet,
} from "../components/mail/mail_format_tools.js";

import { MeetLinkPaymentToMento,
  MeetLinkPaymentToUser
 } from "../components/mail/mail_formats_google_meet.js";


// Helper: send user & admin email
export const sendFormEmail = async (formData, mail) => {

  const ist = new Date(new Date().getTime()) ;
  const emailData = {
    name: formData?.name || "User",
    sessionDate: formData?.sessionDate || "",
    sessionTime: formData?.sessionTime || "",
    subject: "Thank You For Submitting the form",
    time: ist.toLocaleTimeString(),
    contactNo: formData?.contactNo,
    email: formData?.email,
    city: formData.city,
  };
  const emailDataContact = {
    name: formData.fullName || "User",
    email: formData.email,
    contactNo: formData.phoneNumber,
    subject: "Thank You For Contacting Us",
    message: formData.message,
    formSubject: formData.subject,
    submittedAt: new Date(formData.submittedAt).toLocaleString(),
    time: ist.toTimeString().split(" ")[0],
  };

  if (!emailData || !emailData.email) {

  }
  const emailContent = ReactDOMServer.renderToStaticMarkup(
    mail === "form" ? (
      <FormResponseFormatToUser data={formData} />
    ) : mail === "contact" ? (
      <FromResponseFormatToContactus {...emailDataContact} />
    ) : mail === "Depression" ? (
      <DepressionAssessmentResultFormat data={formData} />
    ) : mail === "payment" ? (
      <UserPaymentConfirmation data={formData} />
    ) : mail === "anxiety" ? (
      <AnxietyAssessmentResultFormat data={formData} />
    ) : mail === "health" ? (
      <WellbeingAssessmentResultFormat data={formData} />
    ) : mail === 'google_meet' ?(
      <mail_to_user_for_the_google_meet data={formData} />
    ): null
  );

  if (mail === "form") {
    const emailContentdarsh = ReactDOMServer.renderToStaticMarkup(
      <FormResponseFormatToMento1 {...formData} />
    );

    const emailBody = GenerateEmailHTML(emailContent);
    const emailBodydarsh = GenerateEmailHTML(emailContentdarsh);
    try {
      const userResponse = await sendEmailAPI(
        "send_mail",
        emailData.email,
        emailData.subject,
        emailBody
      );

      const adminResponse = await sendEmailAPI(
        "send_mail",
        process.env.REACT_APP_EMAIL,
        "New Mail Is Submmited",
        emailBodydarsh
      );

      const responses = { ...userResponse, ...adminResponse };

      return responses;
    } catch (error) {
    }
  } else if (mail === "contact") {
    const emailBody = GenerateEmailHTML(emailContent);
    const adminResponse = await sendEmailAPI(
      "send_mail",
      process.env.REACT_APP_EMAIL,
      emailData.subject,
      emailBody
    );

    return adminResponse;
  } else if (mail === "payment") {
    const emailContentdarsh = ReactDOMServer.renderToStaticMarkup(
      <UserPaymentConfirmationToMento data={formData} />
    );
    const emailBodydarsh = GenerateEmailHTML(emailContentdarsh);
    const emailBody = GenerateEmailHTML(emailContent);
    const userResponse = await sendEmailAPI(
      "send_mail",
      emailData.email,
      "Payment Confirmation",
      emailBody
    );

    const adminResponse = await sendEmailAPI(
      "send_mail",
      process.env.REACT_APP_EMAIL,
      "New Payment Has Received ",
      emailBodydarsh
    );
    const responses = { ...userResponse, ...adminResponse };

    return responses;
  } else if (mail === "anxiety") {
    const emailContentdarsh = ReactDOMServer.renderToStaticMarkup(
      <ToolResponsetoMentoFormat data={formData} />
    );
    const emailBodydarsh = GenerateEmailHTML(emailContentdarsh);
    const emailBody = GenerateEmailHTML(emailContent);
    const userResponse = await sendEmailAPI(
      "send_mail",
      emailData.email,
      "We’ve Received Your Anixety Assessment",
      emailBody
    );

    const adminResponse = await sendEmailAPI(
      "send_mail",
      process.env.REACT_APP_EMAIL,
      "New Submission – Anixety Assessment Completed",
      emailBodydarsh
    );
    const responses = { ...userResponse, ...adminResponse };

    return responses;
  } else if (mail === "Depression") {
    const emailContentdarsh = ReactDOMServer.renderToStaticMarkup(
      <ToolResponsetoMentoFormat data={formData} />
    );
    const emailBodydarsh = GenerateEmailHTML(emailContentdarsh);
    const emailBody = GenerateEmailHTML(emailContent);
    const userResponse = await sendEmailAPI(
      "send_mail",
      emailData.email,
      "We’ve Received Your Depression Assessment Test",
      emailBody
    );

    const adminResponse = await sendEmailAPI(
      "send_mail",
      process.env.REACT_APP_EMAIL,
      "New Submission – Depression Assessment Test Completed",
      emailBodydarsh
    );
    const responses = { ...userResponse, ...adminResponse };

    return responses;
  } else if (mail === "health") {
    const emailContentdarsh = ReactDOMServer.renderToStaticMarkup(
      <ToolResponsetoMentoFormat data={formData} />
    );
    const emailBodydarsh = GenerateEmailHTML(emailContentdarsh);
    const emailBody = GenerateEmailHTML(emailContent);
    const userResponse = await sendEmailAPI(
      "send_mail",
      emailData.email,
      "We’ve Received Your General Health Assessment Test",
      emailBody
    );

    const adminResponse = await sendEmailAPI(
      "send_mail",
      process.env.REACT_APP_EMAIL,
      "New Submission – General Health Assessment Completed",
      emailBodydarsh
    );
    const responses = { ...userResponse, ...adminResponse };

    return responses;
  }
   
};

// Exported: payment logic

export const handle_payment = async (formData, form) => {
  if (["individual", "couple", "family"].includes(form)) {
    try {
      const paymentResponse = await initiatePayment(formData);
      // No email sent here (as per your latest instruction)
    } catch (err) {
    }
  }
};

export let response_data = null;
export const handle_service = async (formData, form) => {
  // const [data , setData] = useContext(Context);
  try {
    const submitted_date = new Date().toISOString().split("T")[0];
    formData.submitted_date = submitted_date;

    const endpointMap = {
      individual: "/individual",
      couple: "/couple",
      family: "/family_friend",
      contact: "/contact_form",
    };

    const endpoint = endpointMap[form];
    if (!endpoint) throw new Error("Invalid form type");

    // Step 1: Save to database
    const response = await postData(endpoint, formData);

    // setData(response.data)
    const ist = new Date(new Date().getTime());

    // Step 2: Send email and initiate payment (only if DB success)
    if (response.status === "success") {
      if (
        endpoint === "/individual" ||
        endpoint === "/couple" ||
        endpoint === "/family_friend"
      ) {
        const emailData = {
          name: formData.name || "User",
          sessionDate: formData.sessionDate || "",
          sessionTime: formData.sessionTime || "",
          subject: "Thank You For Submitting the form",
          time: ist.toLocaleTimeString(),
          contactNo: formData.contactNo,
          email: formData.email,
        };
        formData.subject = "Thank You For Submitting the form";
        formData.time = ist.toLocaleTimeString();
       await sendFormEmail(formData, "form");
      } else if (endpoint === "/contact_form") {
        const emailData = {
          name: formData.name || "User",
          subject: formData.subject || "Contact Form Submission",
          email: formData.email,
          message: formData.message || "",
          ...formData,
        };
         await sendFormEmail(formData, "contact");
      }

      return response;
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};


export const handle_tools_services = async (formData, form) => {
  try {
    const submitted_date = new Date().toISOString().split("T")[0];
    formData.submitted_date = submitted_date;

    const endpointMap = {
      depression: "/depressiontest",
      anxiety: "/anxietytest",
      health: "/health",
      blog: "/blog",
      payment: "/payment",
    };

    const endpoint = endpointMap[form];
    if (!endpoint) {
      throw new Error("Invalid form type");
    }

    const response = await postDataBS(endpoint, formData);

    const ist = new Date(new Date().getTime());


    if (response?.status === "success") {
      if (form === "payment") {
        const mail_response = await sendFormEmail(formData, "payment");
      } else if (form === "anxiety") {
        const mail_response = await sendFormEmail(formData, "anxiety");
      } else if (form === "depression") {
        const mail_response = await sendFormEmail(formData, "Depression");
      } else if (form === "health") {
        const mail_response = await sendFormEmail(formData, "health");
      } else {
        const emailData = {
          name: formData?.name || "User",
          sessionDate: formData?.sessionDate || "",
          sessionTime: formData?.sessionTime || "",
          subject: "Thank You For Submitting the form",
          time: ist.toLocaleTimeString(),
          contactNo: formData?.contactNo,
          email: formData?.email,
        };
        const mail_response = await sendFormEmail(emailData, form);
      }
    }

    return response;
  } catch (error) {
    throw error;
  }


 ;
}
export const mailforthemeet = async (mail_data) => {
try {

  console.log("inside the mail for the meet ",mail_data)
  if(mail_data){

    const mento_mail = process.env.REACT_APP_EMAIL || 'connnectmento@gmail.com'


    const email_body = ReactDOMServer.renderToStaticMarkup(<MeetLinkPaymentToUser data={mail_data}/>)

    console.log(email_body)

    const email_body_to_mento = ReactDOMServer.renderToStaticMarkup(<MeetLinkPaymentToMento data={mail_data}/>)

    // const email_body_to_mento = <MeetLinkPaymentToMento data={mail_data}/>


    console.log(email_body_to_mento)

   const response =await sendEmailAPI('send_mail',mail_data.email,'Session Has been Booked',email_body)
  
  
   const responsemento = await sendEmailAPI('send_mail', mento_mail ,'New Meet have been made',email_body_to_mento)
   
   return {response, responsemento}

  
  
  }else{
    return "The mail data is invalid"
  }
 

} catch (error) {
  throw new Error(error)
}
};